import http from "@/services/axios";
import { defineStore } from "pinia";
import { ref } from "vue"; // Removed onUnmounted from here

export const useNotificationStore = defineStore("notifications", () => {
    const notifications = ref([]);
    const currentPage = ref(1);
    const perPage = ref(15);
    const total = ref(0);
    const lastPage = ref(1);
    const count = ref(0);

    let pollInterval = null;

    const fetch_all_notifications = async (page = 1, append = false) => {
        try {
            // Fix: Ensure per_page is treated as a primitive number, not an array
            const cleanPerPage = Array.isArray(perPage.value)
                ? perPage.value[0]
                : perPage.value;

            const { data } = await http.get("/notifications", {
                params: {
                    page,
                    per_page: parseInt(cleanPerPage) || 15 // Fallback to 15 if empty
                },
            });

            if (append) {
                notifications.value = [...notifications.value, ...data.data];
            } else {
                notifications.value = data.data;
            }

            currentPage.value = data.meta.current_page;

            // Fix: Make sure you extract the raw number here 
            // in case data.meta.per_page is returning an array from the backend
            perPage.value = Array.isArray(data.meta.per_page)
                ? parseInt(data.meta.per_page[0])
                : parseInt(data.meta.per_page);

            total.value = data.meta.total;
            lastPage.value = data.meta.last_page;

            return notifications.value;
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    };

    const load_more_notifications = async () => {
        if (currentPage.value < lastPage.value) {
            await fetch_all_notifications(currentPage.value + 1, true);
        }
    };

    const count_all_notif = async () => {
        try {
            const { data } = await http.get("/notifications/count");
            // FIXED: Target 'total_notifications' matching Laravel JSON response key
            count.value = data.total_notifications;
            return data.total_notifications;
        } catch (error) {
            console.error("Error fetching notification count:", error);
        }
    };

    const mark_as_read = async (id) => {
        try {
            // FIXED: Changed from POST to PUT and unified route with Backend endpoint
            await http.put(`/notifications/${id}/read`);

            // Optimistic local state updates
            notifications.value = notifications.value.map((notif) =>
                notif.id === id ? { ...notif, read_at: new Date().toISOString() } : notif
            );

            await count_all_notif();
        } catch (error) {
            console.error("Error marking notification as read:", error);
        }
    };

    const mark_all_as_read = async () => {
        try {
            await http.put("/notifications/read-all");

            // Optimistic local state updates
            notifications.value = notifications.value.map((notif) => ({
                ...notif,
                read_at: new Date().toISOString(),
            }));

            await count_all_notif();
        } catch (error) {
            console.error("Error marking all notifications as read:", error);
        }
    };

    // FIXED: Defaulted interval to 30,000ms (30 seconds) instead of 300ms
    const startPolling = (interval = 30000) => {
        if (pollInterval) return;
        pollInterval = setInterval(async () => {
            await count_all_notif();
        }, interval);
    };

    const stopPolling = () => {
        if (pollInterval) {
            clearInterval(pollInterval);
            pollInterval = null;
        }
    };

    return {
        notifications,
        currentPage,
        perPage,
        total,
        lastPage,
        count,
        fetch_all_notifications,
        load_more_notifications,
        count_all_notif,
        startPolling,
        stopPolling,
        mark_as_read,
        mark_all_as_read,
    };
});